import useBatchUrlAnalysisProcessesPolling from "../../deepAnalysis/process/hooks/useBatchUrlAnalysisProcessesPolling";
import useWebsiteSetupStatus from "../../deepAnalysis/websiteIndexEntry/hooks/useWebsiteSetupStatus";

export default function useDeepAnalysisInProgress(websiteGuid: string | undefined) {
    const {
        websiteStatus: sitemapImportStatus,
        isLoadingWebsiteStatus: isLoadingSitemapImportStatus,
    } = useWebsiteSetupStatus(websiteGuid);

    const status = sitemapImportStatus?.status;

    // if sitemap import status is "completed", we need to fetch active deep analysis processes
    const {
        isLoadingRunningProcesses: isLoadingDeepAnalysisProcesses,
        isRunningBatchAnalysis: isRunningDeepAnalysis,
        activeBatchUrlAnalysisProcess
    } = useBatchUrlAnalysisProcessesPolling(websiteGuid, status === 'completed');

    // Deep analysis is in progress if sitemap is importing or batch analysis is running
    const isDeepAnalysisInProgress = status === 'importing_sitemaps' || isRunningDeepAnalysis;

    // Debug logs
    // console.log('useDeepAnalysisInProgress:', {
    //     status,
    //     isRunningDeepAnalysis,
    //     isDeepAnalysisInProgress,
    //     activeBatchUrlAnalysisProcess: activeBatchUrlAnalysisProcess?.status
    // });

    return {
        sitemapImportStatus,
        isLoadingSitemapImportStatus,
        isLoadingDeepAnalysisProcesses,
        isRunningDeepAnalysis,
        activeDeepAnalysisProcess: activeBatchUrlAnalysisProcess,
        isDeepAnalysisInProgress
    };
}